import { AuthAsideContent } from './AuthWellnessVisual';
import { ThemeToggle } from '../ThemeToggle';

interface AuthShellProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export function AuthShell({ title, subtitle, children }: AuthShellProps) {
  return (
    <div className="auth-page">
      <aside className="auth-aside">
        <div className="auth-aside-inner">
          <div className="auth-brand">
            <span className="auth-brand-mark" aria-hidden>
              ◉
            </span>
            MyLighthouse Admin
          </div>
          <p className="auth-aside-tagline">Secure operations for verified mental health care</p>
          <AuthAsideContent variant="admin" />
        </div>
        <div className="auth-aside-glow auth-aside-glow-1" aria-hidden />
        <div className="auth-aside-glow auth-aside-glow-2" aria-hidden />
      </aside>

      <div className="auth-main">
        <div className="mb-4 flex justify-end">
          <ThemeToggle compact />
        </div>
        <div className="auth-ambient" aria-hidden>
          <span className="auth-ambient-blob auth-ambient-blob-1" />
          <span className="auth-ambient-blob auth-ambient-blob-2" />
        </div>
        <div className="auth-card">
          <div className="auth-card-header">
            <h1 className="auth-title">{title}</h1>
            {subtitle && <p className="auth-subtitle">{subtitle}</p>}
          </div>
          {children}
        </div>
        <p className="auth-admin-footer">
          Restricted access · MFA required · All actions are logged
        </p>
      </div>
    </div>
  );
}
